import {
  AUTHENTICATED_ENTRY,
  // UNVERIFIED_ENTRY ,
} from "configs/AppConfig";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PublicRoute = () => {
  const { token, userData } = useSelector((state) => state.auth);
  const location = useLocation();

  // Redirect authenticated and verified users to the authenticated entry
  if (token && userData?.status === ("VALIDATED" || "Trial Period")) {
    return <Navigate to={AUTHENTICATED_ENTRY} />;
  }

  // Redirect authenticated but unverified users to the pending verification entry
  //   if (
  //     token &&
  //     userData?.status === "PENDING" &&
  //     location.pathname !== UNVERIFIED_ENTRY
  //   ) {
  //     return <Navigate to={UNVERIFIED_ENTRY} />;
  //   }

  // Render the children routes for unauthenticated users
  return <Outlet />;
};

export default PublicRoute;
